import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/analytics';

// Hook for tracking page views automatically
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;
    
    const timeoutId = setTimeout(() => {
      const pageTitle = document.title;
      console.log('[GA] usePageTracking: Tracking page view', pagePath);
      trackPageView(pagePath, pageTitle);
    }, 50);

    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.search]);
};

// Hook for component-specific analytics
export const useAnalytics = () => {
  return {
    trackPageView,
    // Add other analytics functions as needed
  };
};
